import { Injectable } from "@angular/core";
import { NmsAutoUpdaterComponent } from "./nms-auto-updater.component";

/**
 * Registra a referência do nms-auto-updater (@see NmsAutoUpdaterComponent) para ser
 * possível de acessá-lo através de controllers antigas do AngularJS.
 *
 * Foi criado para ter acesso ao componente de auto-update de forma mais fácil
 * e sem a necessidade de artifícios de AngularJs, evitando assim a criação de código
 * em formato defasado.
 */
@Injectable({
    providedIn: "root"
})
export class NmsAutoUpdaterRegistryService {

    private readonly nmsAutoUpdaterComponentMap: Map<string, NmsAutoUpdaterComponent> = new Map()

    register(id: string, component: NmsAutoUpdaterComponent): void {
        this.nmsAutoUpdaterComponentMap.set(id, component);
    }

    retrieve(id: string): NmsAutoUpdaterComponent {
        return this.nmsAutoUpdaterComponentMap.get(id);
    }

    delete(id: string): void {
        this.nmsAutoUpdaterComponentMap.delete(id);
    }
}
